import isEqual from 'lodash.isequal';

/**
 * Helper to compare canvas configs ignoring volatile fields that don't affect rendering.
 * Used to prevent infinite loops when backend regenerates IDs or signed URLs during polling.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const areCanvasConfigsEqual = (prev: any, next: any): boolean => {
  if (prev === next) return true;
  if (!prev || !next) return false;

  // Ignore volatile fields that change on polling
  const ignoredKeys = ['debug', 'version', 'extra'];
  const prevClean = { ...prev };
  const nextClean = { ...next };

  ignoredKeys.forEach((key) => {
    delete prevClean[key];
    delete nextClean[key];
  });

  // Start Normalization of objects
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const normalizeObjects = (obj: any) => {
    // 1. Clean objects array
    if (obj && obj.objects && Array.isArray(obj.objects)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      obj.objects = obj.objects.map((item: any) => {
        const cleanItem = { ...item };
        // Ignore volatile fields that might change on backend regeneration
        delete cleanItem.id; // Fabric ID
        delete cleanItem.src; // Signed URLs
        delete cleanItem.available_images; // Lists of signed URLs
        return cleanItem;
      });
    }

    // 2. Clean background image (creates infinite loop if src changes)
    if (obj && obj.backgroundImage) {
      // Fabric stores bg image as an object sometimes
      if (typeof obj.backgroundImage === 'object') {
        delete obj.backgroundImage.src;
        delete obj.backgroundImage.crossOrigin;
      }
    }

    // 3. Clean overlay image
    if (obj && obj.overlayImage) {
      if (typeof obj.overlayImage === 'object') {
        delete obj.overlayImage.src;
        delete obj.overlayImage.crossOrigin;
      }
    }
  };

  normalizeObjects(prevClean);
  normalizeObjects(nextClean);
  // End Normalization

  return isEqual(prevClean, nextClean);
};
